

export const Home = "/";
export const Info = "/information";
export const Analytics = "/analytics";
export const AboutUs = "/aboutus";
export const Login = "/login";

